<i18n>
{
    "en_US": {
        "fail-password-confirm": "Password and confirmation aren't equal...",
        "missing-email": "Email can't be blank",
        "missing-username-password": "A username and password must be present",
        "nevermind": "Nevermind",
        "register": "Register a new account"
    },
    "fr_FR": {
        "fail-password-confirm": "Le mot de passe et sa confirmation sont différents...",
        "missing-email": "L'email ne peut pas être vide",
        "missing-username-password": "L'identifiant et le mot de passe sont nécessaires",
        "nevermind": "Abandonner",
        "register": "Créer un compte"
    }
}
</i18n>

<template>
    <form v-on:submit.prevent="register">
        <h1 class="text-left" v-text="$t('register')"></h1>

        <slot name="flashes" />

        <input-check-login-availability v-model="username" v-bind:disabled="pending.register" />

        <input-check-email-availability v-model="email" v-bind:disabled="pending.register" />

        <input-password-reveal v-model="password" v-bind:disabled="pending.register" />
        <input-password-confirm v-model="confirm" v-bind:password="password" v-bind:disabled="pending.register" />

        <button class="btn btn-lg btn-primary btn-block" type="submit" v-bind:disabled="isAllowedButton">
            <loader-basic-spinner v-if="pending.register" />
            <a v-else v-text="$t('register')"></a>
        </button>

        <a class="nevermind" v-on:click="login" v-text="$t('nevermind')"></a>
    </form>
</template>

<script>
    import InputCheckLoginAvailability from "inputs/CheckLoginAvailability";
    import InputCheckEmailAvailability from "inputs/CheckEmailAvailability";
    import InputPasswordReveal from "inputs/PasswordReveal";
    import InputPasswordConfirm from "inputs/PasswordConfirm";
    import LoaderBasicSpinner from "loaders/BasicSpinner";
    import { mapState, mapMutations, mapActions } from "vuex";

    export default {
        name: "Register",
        data: function() {
            return {
                username: "",
                email: "",
                password: "",
                confirm: ""
            };
        },
        components: {
            LoaderBasicSpinner,
            InputCheckLoginAvailability,
            InputCheckEmailAvailability,
            InputPasswordReveal,
            InputPasswordConfirm
        },
        mounted: function() {
            $(this.$el).bootstrapMaterialDesign();
            $(this.$el).find("#inputUsername").focus();
        },
        computed: {
            isAllowedButton: function() {
                return this.pending.register || !this.username || !this.email || !this.password || !this.confirm;
            },
            ...mapState("language", ["language"]),
            ...mapState("user", ["pending"])
        },
        methods: {
            login: function() {
                this.$router.push({
                    name: "login"
                });
            },
            register: function() {
                if(!this.username || !this.password || !this.confirm) {
                    this.addFlash({
                        type: "error",
                        message: this.$t("missing-username-password"),
                        onlyCurrentRoute: true
                    });
                    return;
                }

                if (!this.email) {
                    this.addFlash({
                        type: "error",
                        message: this.$t("missing-email"),
                        onlyCurrentRoute: true
                    });
                    return;
                }

                if (!this.password || this.password !== this.confirm) {
                    this.addFlash({
                        type: "error",
                        message: this.$t("fail-password-confirm"),
                        onlyCurrentRoute: true
                    });
                    return;
                }

                // Do register
                this.actionRegister({
                    login: this.username,
                    email: this.email,
                    password: this.password,
                    language: this.language,
                    // Ui preferences for this user
                    ui_preferences: {
                    },
                    app_preferences: {
                        similarity: 0.3,
                        index_language: (this.language === "fr_FR") ? "french" : "english"
                    }
                })
                .then(function() {
                    this.$Progress.increase(30);
                    this.$router.push({ name: "login" });
                }.bind(this))
                .catch(function() {});
            },
            ...mapMutations("flash", ["addFlash"]),
            ...mapActions("user", {
                actionRegister: "register"
            })
        }
    }
</script>

<style scoped>
    h1 {
        margin-top: 20px;
        margin-bottom: 10px;
        color: #666;
        font-weight: 300;
        font-size: 20px;
    }
    img {
        margin-bottom: 10px;
    }
    .bmb-form-group {
        padding-top: 1.3rem !important;
    }
    button {
        margin-bottom: 0;
        margin-top: 10px;
        font-weight: 100;
        font-size: 18px !important;
        line-height: 1.3333333333;
    }
    .bmd-label-floating {
        left: 0;
    }
    .nevermind {
        display: block;
        margin-top: 25px;
        font-size: 14px;
        font-weight: 300;
        cursor: pointer;
    }
    .form-group label {
        font-weight: bold;
        font-size: 14px;
    }
    .container-fluid {
        margin-top: 30px;
    }
    .href {
        color: #3e8ef7;
        font-weight: 100;
        font-size: 14px;
        cursor: pointer;
    }
    .btn-block {
        margin-top: 45px;
    }
</style>